import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'components';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Wrapper, Item, Content, Label } from './FiltersControls.styled';

const FiltersControls = ({
  perPageConfig,
  perPageSelected,
  perPageOnChange,
  sortByConfig,
  sortBySelected,
  sortByOnChange,
}) => {
  const { t } = useTranslation();
  if (!sortByOnChange && !perPageOnChange) return null;

  return (
    <Wrapper>
      {sortByOnChange && (
        <Item>
          <Label>{t('global.sortBy')}</Label>
          <Content>
            <Select
              small
              onChange={sortByOnChange}
              value={find(sortByConfig.options, { value: sortBySelected }) || null}
              options={sortByConfig.options}
              name={sortByConfig.name}
            />
          </Content>
        </Item>
      )}

      {perPageOnChange && (
        <Item>
          <Label>{t('global.perPage')}</Label>
          <Content short>
            <Select
              small
              onChange={perPageOnChange}
              value={find(perPageConfig.options, { value: perPageSelected }) || null}
              options={perPageConfig.options}
              name={perPageConfig.name}
            />
          </Content>
        </Item>
      )}
    </Wrapper>
  );
};

FiltersControls.propTypes = {
  perPageConfig: PropTypes.shape({}),
  perPageSelected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  perPageOnChange: PropTypes.func,
  sortByConfig: PropTypes.shape({}),
  sortBySelected: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sortByOnChange: PropTypes.func,
};

FiltersControls.defaultProps = {
  perPageConfig: {
    name: 'perPage',
    options: [
      { label: 1, value: 1 },
      { label: 10, value: 10 },
      { label: 20, value: 20 },
      { label: 50, value: 50 },
      { label: 100, value: 100 },
    ],
  },
  perPageSelected: 10,
  perPageOnChange: null,
  sortByConfig: {
    name: 'sortBy',
    options: [
      { label: 'Date: descending', value: 'createdDate.desc' },
      { label: 'Date: ascending', value: 'createdDate.asc' },
      { label: 'Start date: descending', value: 'startDate.desc' },
      { label: 'Start date: ascending', value: 'startDate.asc' },
      { label: 'Name: descending', value: 'name.desc' },
      { label: 'Name: ascending', value: 'name.asc' },
    ],
  },
  sortBySelected: 'createdDate.desc',
  sortByOnChange: null,
};

export default FiltersControls;
